import React from 'react';
import { Outlet, createRootRouteWithContext } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import { createRouter } from '@tanstack/react-router';
import { routes } from '@/routes';

export type RouterContext = Record<string, never>;

export const rootRoute = createRootRouteWithContext<RouterContext>()({
  component: () =>
    React.createElement(React.Fragment, {}, [
      React.createElement(Outlet),
      React.createElement(TanStackRouterDevtools),
    ]),
});

export const router = createRouter({
  routeTree: rootRoute.addChildren(Object.values(routes)),
  context: {},
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
